/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_CopiedInputs */

const en_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied!`)
};

const de_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert!`)
};

const fr_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié !`)
};

const es_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Copiado!`)
};

const it_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiato!`)
};

const nl_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekopieerd!`)
};

const pl_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skopiowano!`)
};

const fi_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopioitu!`)
};

const da_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieret!`)
};

const sv_salary_negotiate_copied = /** @type {(inputs: Salary_Negotiate_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopierat!`)
};

/**
* | output |
* | --- |
* | "Copied!" |
*
* @param {Salary_Negotiate_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_copied = /** @type {((inputs?: Salary_Negotiate_CopiedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_CopiedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_copied(inputs)
	if (locale === "fr") return fr_salary_negotiate_copied(inputs)
	if (locale === "es") return es_salary_negotiate_copied(inputs)
	if (locale === "it") return it_salary_negotiate_copied(inputs)
	if (locale === "nl") return nl_salary_negotiate_copied(inputs)
	if (locale === "pl") return pl_salary_negotiate_copied(inputs)
	if (locale === "fi") return fi_salary_negotiate_copied(inputs)
	if (locale === "da") return da_salary_negotiate_copied(inputs)
	if (locale === "sv") return sv_salary_negotiate_copied(inputs)
	return en_salary_negotiate_copied(inputs)
});